import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import constants from '../constants';

const Navigation = ({ links = [], contentLink = null }) => {
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
    }

    let additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    let hiddenClasses = "";
    let isExternalLink = contentLink && contentLink.isExternalLink;

    if (contentLink) {
        if (contentLink.hideForMobile || contentLink.hideForTablet || contentLink.hideForDesktop) {
            if (!contentLink.hideForMobile && !contentLink.hideForTablet) {
                hiddenClasses = " hide-for-large-only";
            }
            else if (!contentLink.hideForMobile && !contentLink.hideForDesktop) {
                hiddenClasses = " hide-for-medium-only";
            }
            else if (!contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " hide-for-small-only";
            }
            else if (contentLink.hideForMobile && contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " show-for-large";
            }
            else if (contentLink.hideForMobile && contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " show-for-large";
            }
            else if (contentLink.hideForMobile && !contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " show-for-medium";
            }
            else if (contentLink.hideForMobile && contentLink.hideForTablet && contentLink.hideForDesktop) {
                hiddenClasses = " hide";
            }
        }
        additionClass += " " + hiddenClasses;
    }


    return (
        <Fragment>
            {!contentLink ? (
                <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}><label>{translate('common.mobile.menu')}</label></a>
            ) : (
                    <Fragment>
                        <a target={`${isExternalLink ? '_blank' : '_self'}`} className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''}`}
                            href={(contentLink.isExternalLink && contentLink.externalLink) || contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLink.name }} >
                        </a>
                        {links.length > 0 &&
                            <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                        }
                    </Fragment>
                )}

            {links.length > 0 &&
                <div className="navbar__menu" ref={menuRef} test={links.length}>
                    <div className="navbar__space"></div>
                    <ul>
                        <li className="navbar__menu-header">
                            {!contentLink ? (
                                <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}>{/*<label>{translate('common.mobile.close')}</label>*/}</span>
                            ) : (
                                    <Fragment>
                                        <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                                        <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
                                    </Fragment>
                                )}

                        </li>
                        {!contentLink &&
                            <li className="navbar__item flags"> <div id="websiteSelector"></div></li>
                        }
                        {links.length > 0 && links.map((link, i) => !link.name ? null :
                            <li className="navbar__item" key={`${link.name}-${i}`}>
                                <Navigation links={link.links} contentLink={link} />
                            </li>
                        )}
                        {!contentLink &&
                            <Fragment>
                                {constants.topLinks && constants.topLinks.map((link, linkIndex) => !link.accessibleByUser ? null :
                                    <li className="navbar__item top-links hide-for-large" key={`link${linkIndex}`}><a className="navbar__link" href={link.href} >{link.text}</a></li>
                                )}

                                {!constants.isLoggedIn && constants.topAlternativeLinks && constants.topAlternativeLinks.map((altLink, altLinkIndex) => altLink.hideForUser ? null :
                                    <li className="navbar__item top-links hide-for-large alt-link" key={`altLink${altLinkIndex}`}><a className="navbar__link" href={altLink.linkUrl}>{altLink.linkName}</a></li>
                                )}
                                {constants.isLoggedIn &&
                                    <li className="navbar__item top-links hide-for-large" key='export' id="mobile-exportmenu"></li>
                                }
                                {constants.isLoggedIn &&
                                    <li className="navbar__item top-links hide-for-large" key='dropzone' id="mobile-dropzone"></li>
                                }
                                {constants.isLoggedIn &&
                                    <li className="navbar__item top-links hide-for-large" key='favourites' id="mobile-favourites"></li>
                                }
                            </Fragment>
                        }
                    </ul>
                    <div className="navbar__space"></div>
                </div>
            }

        </Fragment>
    )
}

export default Navigation;